/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { BillingAddress } from './billing-address';
// May contain unused imports in some cases
// @ts-ignore
import type { Customer } from './customer';
// May contain unused imports in some cases
// @ts-ignore
import type { OrderDetails } from './order-details';

/**
 * Request to create a payment intent.  **Amount aliasing.** `amount` is the canonical name; `totalAmount` is a permanently supported alias. Supply either name; supplying both is tolerated only when the values are equal. Conflicting values, or neither name, are rejected with `INVALID_PAYMENT_INTENT_PAYLOAD`. Presence is enforced by the platform after the alias is collapsed, which is why neither name is schema-`required`.  **What the amount means.** On a Fiserv Forward merchant the amount is the merchant\'s ticket: any buyer-borne fees priced from the merchant\'s configuration are added on top, and the platform computes the buyer\'s charged total. On other processors the amount is the charged total and supplied fees pass through unchanged.  **Service fee:** supply `serviceFees` to set the service fee for this payment. A supplied value — including an explicit `0` — is charged exactly as sent and takes precedence over any service fee configured for the merchant. Omit the field and the fee is priced from the merchant\'s configuration (or is zero when none is configured). On a Fiserv Forward merchant who pays the fee follows the merchant\'s fee schedule (Who Pays), exactly as a configured fee does: merchant-pays deducts the fee from the merchant\'s share and the buyer is charged the amount as sent; buyer-pays adds the fee to the buyer\'s total. No property of the payment intent moves a fee between the buyer and the merchant.  **Processing fee:** `platformFees` is deprecated. It is honoured on ProPay merchants only and ignored on Fiserv Forward merchants, where the processing fee and the FanFair fee are always priced from the merchant\'s configuration.  **Fee constraint:** `serviceFees` is a component of `amount` and must not exceed it. The merchant\'s portion (`amount` minus all fees) must be at least as large as the combined fees; violations are rejected with `FEES_EXCEED_MERCHANT_AMOUNT`. 
 * @export
 * @interface CreatePaymentIntentRequest
 */
export interface CreatePaymentIntentRequest {
    /**
     * Merchant account ID that the payment intent is for
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'merchantId': string;
    /**
     * Total payment amount in minor units (e.g., cents for USD, pence for GBP). The total of the amount to pay the merchant + service fees + processor. Canonical name; `totalAmount` is a permanently supported alias. 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'amount'?: number;
    /**
     * Alias for `amount`, supported indefinitely — supply either name. Prefer `amount` on new integrations. 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'totalAmount'?: number;
    /**
     * Service fee for this payment in minor units. A supplied value — including an explicit `0` — is charged exactly as sent, taking precedence over any service fee configured for the merchant. Omit it and the platform prices the fee from the merchant\'s fee configuration. On a Fiserv Forward merchant who pays the fee follows the merchant\'s fee schedule (Who Pays), exactly as a configured fee does: merchant-pays deducts it from the merchant\'s share, buyer-pays adds it to the buyer\'s total. 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'serviceFees'?: number;
    /**
     * Deprecated. Honoured on ProPay merchants only, where it passes through as the processing fee exactly as sent. Ignored on Fiserv Forward merchants: the processing fee and the FanFair fee are priced from the merchant\'s configuration whatever is sent here. 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     * @deprecated
     */
    'platformFees'?: number;
    /**
     * ISO 4217 currency code. Only USD currently supported
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'currency': CreatePaymentIntentRequestCurrencyEnum;
    /**
     * The reference for the transaction. This will appear on the customer\'s statement. Can only contain letters, numbers and spaces 
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'merchantReference': string;
    /**
     * URL to redirect customer after successful payment
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'returnUrl'?: string;
    /**
     * URL to redirect customer if payment is cancelled
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'cancelUrl'?: string;
    /**
     * Optional description of the payment
     * @type {string}
     * @memberof CreatePaymentIntentRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Customer}
     * @memberof CreatePaymentIntentRequest
     */
    'customer'?: Customer;
    /**
     * 
     * @type {BillingAddress}
     * @memberof CreatePaymentIntentRequest
     */
    'billingAddress'?: BillingAddress;
    /**
     * 
     * @type {OrderDetails}
     * @memberof CreatePaymentIntentRequest
     */
    'orderDetails'?: OrderDetails;
    /**
     * Arbitrary key-value pairs for merchant use. Keys must be max 100 characters and cannot contain square brackets. Values must be max 500 characters.
     * @type {{ [key: string]: string; }}
     * @memberof CreatePaymentIntentRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * Optional custom timeout for the payment session in minutes. If not provided, defaults to 45 minutes. Minimum: 5 minutes, Maximum: 180 minutes (3 hours). The timeout value determines how long the session remains valid before expiring. After expiration, the session cannot be used for payment processing. 
     * @type {number}
     * @memberof CreatePaymentIntentRequest
     */
    'timeoutInMinutes'?: number;
}

export const CreatePaymentIntentRequestCurrencyEnum = {
    Usd: 'USD'
} as const;

export type CreatePaymentIntentRequestCurrencyEnum = typeof CreatePaymentIntentRequestCurrencyEnum[keyof typeof CreatePaymentIntentRequestCurrencyEnum];


